import {
  Avatar,
  Button,
  IconButton,
  MenuItem,
  Modal,
  Paper,
  Typography,
} from '@mui/material';
import { styled } from '@mui/system';

import { shouldForwardProp } from '@helpers/misc';

import { ProfileSelectorModalMenuItemTypographyStyledProps } from './types';

export const ProjectSelectorModalStyled = styled(Modal)({
  width: '100vw',
  height: '100vh',
});

export const ProjectSelectorModalPaperStyled = styled(Paper)(({ theme }) => ({
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  padding: theme.spacing(2),
  gap: theme.spacing(2),
}));

export const ProjectSelectorModalIconButtonStyled = styled(IconButton)({
  marginLeft: 'auto',
});

export const ProfileSelectorModalButtonOpenStyled = styled(Button)(
  ({ theme }) => ({
    textAlign: 'start',
    height: theme.spacing(6),
  })
);

export const ProfileSelectorModalButtonSubmitStyled = styled(Button)(
  ({ theme }) => ({
    marginTop: 'auto',
    marginBottom: theme.spacing(10),
  })
);

export const ProfileSelectorModalAvatarStyled = styled(Avatar)({
  backgroundColor: 'transparent',
  flexShrink: 0,
  width: 'auto',
  height: 20,
  '& img': {
    objectFit: 'contain',
  },
});

export const ProfileSelectorModalButtonOpenTypographyStyled = styled(
  Typography
)({
  flexGrow: 1,
});

export const ProfileSelectorModalMenuItemTypographyStyled = styled(Typography, {
  shouldForwardProp: (prop) =>
    shouldForwardProp<ProfileSelectorModalMenuItemTypographyStyledProps>(
      ['isSelected'],
      prop
    ),
})<ProfileSelectorModalMenuItemTypographyStyledProps>(({ isSelected }) => {
  return {
    flexGrow: 1,
    fontWeight: isSelected ? 600 : 400,
  };
});

export const ProfileSelectorModalMenuItemStyled = styled(MenuItem)(
  ({ theme }) => ({
    '&.Mui-selected': { backgroundColor: theme.palette.secondary.light },
    display: 'flex',
    flexDirection: 'row',
  })
);
